import React from "react";
import { AppCaregiver } from "../system/AppState/AppCaregiverState";
import { withDefault } from "../utils/withDefault";
import AsyncImage from "./Generic/AsyncImage";

interface Props {
  caregiver: AppCaregiver;
  onClick: () => void;
}

const CaregiverCard = (props: Props) => {
  const photoUrl = withDefault(props.caregiver.photoUrl, "/assets/default_profile.png");

  return (
    <div className="CaregiverCard" onClick={props.onClick}>
      <AsyncImage src={photoUrl} className="__avatar" />
      <div className="__content">
        <h4>
          {props.caregiver.firstName} {props.caregiver.lastName}
        </h4>
        <span>#{props.caregiver.id}</span>
      </div>
    </div>
  );
};

export default React.memo(CaregiverCard);
